import React, {useEffect} from 'react'
import styled from 'styled-components'

import {ComponentValue, InputComponentProps} from './types'

import {Typography} from '~/components/general/typography/Typography'
import {Container} from '~/components/general/container/Container'
import {StyledDashboardInnerCardTableCell} from '~/components/facility/GeneralDataCard.styled'

const CalculatedValue = styled.div`
  padding: ${({theme}) => `${theme.spacing.xxs} ${theme.spacing.md}`};
  border: 1px solid ${({theme}) => theme.colors.inputBorder};
  border-radius: ${({theme}) => theme.borderRadius.xs};
  background-color: ${({theme}) => theme.colors.grey.grey50};
`

type CalculatedFieldProps = InputComponentProps & {
  calculation: (data: ComponentValue[]) => string | undefined
}

export const CalculatedField: React.FC<CalculatedFieldProps> = ({
  title,
  name,
  currentData,
  calculation,
  onUpdate,
}) => {
  const [value, setValue] = React.useState<string | undefined>(undefined)

  useEffect(() => {
    const newValue = calculation(currentData)
    if (newValue === value || (newValue === undefined && value === '-')) {
      return
    }
    setValue(newValue ?? '-')

    // If the new value is null or undefined and there's no data for this field, just return.
    if (
      (newValue === undefined || newValue === null) &&
      !currentData.some((data) => data.name === name)
    ) {
      return
    }

    // If the new value is different from the current value, update the data.
    if (
      !currentData.some((data) => data.name === name && data.value === newValue)
    ) {
      onUpdate([{name, value: newValue}])
    }
  }, [currentData, setValue, onUpdate, calculation, name, value])

  return (
    <StyledDashboardInnerCardTableCell>
      <Container direction="column">
        <Typography weight="medium" size="sm">
          {title}
        </Typography>
        <CalculatedValue>
          <Typography size="lg">{value || '-'}</Typography>
        </CalculatedValue>
      </Container>
    </StyledDashboardInnerCardTableCell>
  )
}
